import { disputeSource } from "@redotech/redo-model/disputes/dispute-definition";
import * as z from "zod/v4";

export const generateDisputeActivityLog = {
  name: "generateDisputeActivityLog" as const,
  input: z.object({
    disputeId: z.coerce.bigint(),
    source: z.enum(disputeSource),
    invalidDisputeReason: z.string().optional(),
  }),
  output: z.object({
    success: z.boolean(),
    activityLog: z.string().optional(),
    error: z.string().optional(),
  }),
};
